export const body1ResponsiveSizes = {
  xs: "0.8rem", // Mobile devices
  sm: "0.9rem", // Tablets
  md: "0.9rem", // Small laptops
  lg: "1rem", // Desktops
  xl: "1.1rem", // Large screens
};
